import Head from "next/head";
import styles from "@/styles/Home.module.css";
import { ComponentJetOneSuites } from "@/components/ui/Screens/Account";
import { RouteGuard } from "@/components/RouteGuard";
import { getPageContentBySlug } from "@/stores/apis/apiSettings";
import { WEBSITE_CONTENT_SLUGS } from "@/config/constants";
import Script from "next/script";

export async function getServerSideProps({ query = {} }) {
	const { preview = false } = query;
	let pageWelcomeJ1SContent = null;
	let data = await getPageContentBySlug(WEBSITE_CONTENT_SLUGS.WELCOME_TO_JET_1_SUITES, preview);
	if (data.success) pageWelcomeJ1SContent = data.data;
	return {
		props: {
			pageWelcomeJ1SContent: pageWelcomeJ1SContent,
			preview: preview,
		},
	};
}

export default function AccountJetOneSuites({ pageWelcomeJ1SContent = {}, preview = false }) {
	return (
		<div className={styles.container}>
			<Head>
				<title>Jet 1 Suites</title>
				<link rel="icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				<link rel="manifest" href="/site.webmanifest" />
				<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ffb11a" />
				<meta name="msapplication-TileColor" content="#da532c" />
				<meta name="theme-color" content="#ffffff" />
				<meta
					name="description"
					content="Michigan's top rated private jet charter services, arrive on time and in style, service to the continental United States, call us for private or business travel services."
				></meta>
				<meta
					property="og:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					itemProp="thumbnailUrl"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				/>
				<meta
					name="twitter:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
			</Head>
			<Script src="https://www.googletagmanager.com/gtag/js?id=G-VCNS22HF5D" />
			<Script id="google-analytics">
				{`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'G-VCNS22HF5D');
                `}
			</Script>

			<main style={{ padding: 0, width: "100%", minHeight: "100vh" }}>
				<RouteGuard preview={preview}>
					<ComponentJetOneSuites pageWelcomeJ1SContent={pageWelcomeJ1SContent} preview={preview} />
				</RouteGuard>
			</main>
		</div>
	);
}
